import { styled } from '../../styled-components';

export const DrawerInner = styled.div.attrs({ className: 'DrawerInner' })`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
